<div class="container-login">
  <!-- LOGO del progetto -->
  <div class="logo-login">
    <a href="https://workinc.vtserver.eu/" target="_blank">
      <img src="img/logo_white.png" [attr.alt]="'auth.logo-alt' | translate" />
    </a>
  </div>

  <div class="login-box">
    <h2>{{ 'auth.resend.title' | translate }}</h2>

    <form #resendEmailForm="ngForm" class="form-login" (ngSubmit)="resendMail(resendEmailForm)">
      <app-alert-message [iconStyle]="{ top: '0rem', right: '0rem' }"></app-alert-message>

      <label for="email">{{ 'auth.fields.email' | translate }}</label>
      <input 
        type="email" 
        id="email"
        name="email" 
        [(ngModel)]="email" 
        placeholder="{{ 'auth.forgot-password.email-placeholder' | translate }}" 
        required
        [disabled]="isLoading">

      <button type="submit" class="btn-signin" [disabled]="isLoading">
        <ng-container *ngIf="!isLoading">
          <mat-icon>mark_email_unread</mat-icon>
          <span>{{ 'auth.resend.send' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="isLoading">
          <mat-spinner diameter="20"></mat-spinner>
          <span>{{ 'auth.resend.sending' | translate }}</span>
        </ng-container>
      </button>

      <!-- Back to Login -->
      <div class="login-links">
        <a routerLink="/login" class="link-back">
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'auth.back-to-login' | translate }}</span>
        </a>
      </div>
    </form>
  </div>
</div>
